import React, { useState, useEffect, FunctionComponent, useMemo } from 'react'
import { isEmpty } from 'lodash'
import { Container, Card, Col, Row } from 'reactstrap'
import { useMediaQuery } from 'react-responsive'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Alert from '../../Shared/components/Alert'
import PlayList from './components/PlayList'
import PlayListComponentEmptyPage from './components/PlayListComponentEmptyPage'
import PlaylistsToSetModal from './components/PlaylistsToSetModal'
import './components/style.scss'
import { PlaylistProps } from './PlaylistProps'
import * as S from './styles'

import { getUserSelector } from '../../Redux/selectors/auth'
import { pageInfo, pageViewEvent } from '../../Helpers/tagManager'
import { Playlist } from '../../Types'

const PlayListComponent: FunctionComponent<PlaylistProps> = ({
  playlists,
  changePlaylistGenres,
  changePlaylistInformation,
  updatePlaylists,
  spotifyAccessToken,
  getCuratorRank,
  genres,
  checkPlaylist,
  // @ts-ignore
  user: { playlist_requirement, email },
  setPlaylistRequirement,
  getAutoselectedSpotifyPlaylistGenres,
  setPlaylistGenresLimit,
  updateStatePlaylists,
  languages,
  getPlaylists,
  setDeactivationAlertRead,
}) => {
  const { t } = useTranslation()

  const user = useSelector(getUserSelector)

  const isMobile = useMediaQuery({ maxWidth: 576 })
  const [pageTitle, setPageTitle] = useState<boolean>(true)
  const [modal, setModalValue] = useState(false)
  const [mobileContentModal, setMobileContentModal] = useState(false)
  const [showLangPrefsAlert, setShowLangPrefsAlert] = useState(false)
  const [recentlyAddedPlaylist, setRecentlyAddedPlaylist] = useState(null)

  useEffect(() => {
    if (playlists) {
      const noPrefsExists = playlists.find(
        el =>
          el.meets_conditions &&
          (el.PlaylistLanguages.length === 0 ||
            (el.PlaylistLanguages[0].language_id === 1 &&
              el.PlaylistLanguages.length === 1))
      )
      setShowLangPrefsAlert(!!noPrefsExists)
    }
  }, [playlists])

  useEffect(() => {
    user && pageViewEvent(user, pageInfo.playlists)
  }, [user])

  const languagesFiltered = languages.filter(el => el.id !== 1)
  const languagesSorted = useMemo(() => {
    const elementsToMove = languagesFiltered.filter(
      el => el.id === 2 || el.id === 3
    )
    const elementsRest = languagesFiltered.filter(
      el => el.id !== 2 && el.id !== 3
    )
    return [...elementsToMove, ...elementsRest]
  }, [languagesFiltered])

  const checkEmptiness = (list: Array<Playlist>) => {
    if (!isEmpty(list)) {
      return (
        <PlayList
          // @ts-ignore
          allGenres={genres}
          changePlaylistGenres={changePlaylistGenres}
          changePlaylistInformation={changePlaylistInformation}
          checkPlaylist={checkPlaylist}
          getAutoselectedSpotifyPlaylistGenres={
            getAutoselectedSpotifyPlaylistGenres
          }
          getCuratorRank={getCuratorRank}
          playlist_requirement={playlist_requirement}
          playlists={list}
          setPlaylistGenresLimit={setPlaylistGenresLimit}
          setPlaylistRequirement={setPlaylistRequirement}
          spotifyAccessToken={spotifyAccessToken}
          updatePlaylists={updatePlaylists}
          userEmail={email}
          updateStatePlaylists={updateStatePlaylists}
          languages={languagesSorted}
          getPlaylists={getPlaylists}
          setDeactivationAlertRead={setDeactivationAlertRead}
          setPageTitle={setPageTitle}
          // @ts-ignore
          recentlyAddedPlaylist={recentlyAddedPlaylist}
          // @ts-ignore
          setRecentlyAddedPlaylist={setRecentlyAddedPlaylist}
        />
      )
    }
    return (
      <PlayListComponentEmptyPage
        checkPlaylist={checkPlaylist}
        getCuratorRank={getCuratorRank}
        spotifyAccessToken={spotifyAccessToken}
        updatePlaylists={updatePlaylists}
        // @ts-ignore
        recentlyAddedPlaylist={recentlyAddedPlaylist}
        // @ts-ignore
        setRecentlyAddedPlaylist={setRecentlyAddedPlaylist}
      />
    )
  }

  const openModal = () => {
    setModalValue(!modal)
    if (isMobile) {
      setMobileContentModal(true)
    }
  }

  const closeModal = () => {
    setModalValue(!modal)
    if (isMobile) {
      setMobileContentModal(false)
    }
  }

  return (
    <Container className="dashboard">
      {!mobileContentModal && (
        <>
          {pageTitle && (
            <S.PageTitle>{t('playlistsPage.pageTitle')}</S.PageTitle>
          )}

          {showLangPrefsAlert && (
            <Alert color="warning" icon unclosable>
              <div className="alert__text">
                <div className="alert__title">
                  {t('reviewsPage.vocalSetUpTitle')}
                </div>
                <div>
                  {t('reviewsPage.vocalSetUpText1')} <br />
                  {t('reviewsPage.vocalSetUpText2')}
                </div>
              </div>
              <button
                type="button"
                className="warning__btn"
                onClick={openModal}
              >
                {t('reviewsPage.vocalSetUpBtn')}
              </button>
            </Alert>
          )}
          <Card>{checkEmptiness(playlists)}</Card>
        </>
      )}
      <PlaylistsToSetModal
        setMobileContentModal={setMobileContentModal}
        setModalValue={setModalValue}
        toggle={closeModal}
        modal={modal}
        pageTitle={t('playlistsPage.pageTitle')}
      />
    </Container>
  )
}

export default PlayListComponent
